var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1872_1127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8688 16.5008L21.947 9.42251C22.3868 8.98312 22.3868 8.27019 21.947 7.8308C21.5073 7.39104 20.7951 7.39104 20.3553 7.8308L13.277 14.9091L6.19839 7.8308C5.75863 7.39104 5.04645 7.39104 4.60668 7.8308C4.16691 8.27019 4.16691 8.98312 4.60668 9.42251L11.6853 16.5008L4.60668 23.5791C4.16691 24.0185 4.16691 24.7314 4.60668 25.1708C4.82656 25.3903 5.11474 25.5002 5.40254 25.5002C5.69033 25.5002 5.97851 25.3903 6.19839 25.1704L13.277 18.0921L20.3553 25.1704C20.5752 25.3903 20.8634 25.5002 21.1512 25.5002C21.439 25.5002 21.7271 25.3903 21.947 25.1704C22.3868 24.731 22.3868 24.0181 21.947 23.5787L14.8688 16.5008Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1872_1127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4.27686 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.26db926d7c6257c75a611cd5eecbf783.svg";
export { ForwardRef as ReactComponent };